// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"6c650df8","428":"90fc03a8","986":"4798dfb3"}[chunkId] + ".chunk.css";
};